// src/pages/inventory/LoungeInventory.jsx
import React from 'react';
import InventoryDashboard from '../InventoryDashboard';

const LoungeInventory = () => {
  return <InventoryDashboard locationKey="lounge" />;
};

export default LoungeInventory;